module.exports = __webpack_public_path__ + "static/media/allergysymptoms-2@2x.aa7ac47b.jpg";